import type React from 'react';
import type { UserRole } from '@/api/models';
import { UserFormModalView } from './UserFormModalView';
import {
    useUserForm,
    type BranchOption,
    type UserFormInitialValues,
    type UserFormSubmit,
} from './useUserForm';

type UserFormModalProps = {
    mode: 'create' | 'edit';
    isOpen: boolean;
    callerRole: UserRole;
    callerBranchId: string | null;
    branchOptions: BranchOption[];
    initialValues: UserFormInitialValues | null;
    isSelf: boolean;
    error: string | null;
    isSubmitting: boolean;
    onClose: () => void;
    onSubmit: (input: UserFormSubmit) => void;
};

/**
 * Container for the Create / Edit user modal: instantiates `useUserForm`
 * (caller-gated role/field matrix + validation) and hands its output plus the
 * modal-chrome props to the render-only `UserFormModalView`.
 */
export const UserFormModal: React.FC<UserFormModalProps> = ({
    mode,
    isOpen,
    callerRole,
    callerBranchId,
    branchOptions,
    initialValues,
    isSelf,
    error,
    isSubmitting,
    onClose,
    onSubmit,
}) => {
    const form = useUserForm({
        mode,
        isOpen,
        callerRole,
        callerBranchId,
        isSelf,
        initialValues: initialValues ?? undefined,
        onSubmit,
    });

    return (
        <UserFormModalView
            branchOptions={branchOptions}
            error={error}
            form={form}
            isOpen={isOpen}
            isSelf={isSelf}
            isSubmitting={isSubmitting}
            mode={mode}
            onClose={onClose}
        />
    );
};
